import { render, staticRenderFns } from "./mobileMessageModal.vue?vue&type=template&id=96d2de74&"
import script from "./mobileMessageModal.vue?vue&type=script&lang=js&"
export * from "./mobileMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports